import React from 'react';
import { PageTitle } from '@cordata/buffet';

import ClinicalTrialsForm from '~/components/ClinicalTrial/Form';

const ClinicalTrialsAdd = () => (
  <>
    <PageTitle>Add Clinical Trial</PageTitle>

    <ClinicalTrialsForm />
  </>
);

export default ClinicalTrialsAdd;
